import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  size?: 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  href = '#',
  size = 'lg',
  className = '',
  onClick
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-semibold transition-all duration-300 rounded-full relative overflow-hidden group cursor-pointer';
  const sizeClasses = size === 'xl' ? 'px-8 py-4 text-xl md:text-2xl' : 'px-6 py-3 text-lg';
  const colorClasses = 'bg-[var(--accent-amber)] text-[#070b14] hover:bg-[var(--accent-amber-hover)]';
  const handleClick = (e: React.MouseEvent) => {
    if (href.startsWith('#') && href.length > 1) {
      e.preventDefault();
      const targetId = href.slice(1);
      // Small delay to ensure DOM is ready
      requestAnimationFrame(() => {
        const target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }
    onClick?.();
  };
  return <motion.a href={href} onClick={handleClick} target={undefined} rel={undefined} className={`${baseClasses} ${sizeClasses} ${colorClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} initial={{
    boxShadow: '0 0 0 rgba(212, 165, 116, 0)'
  }} animate={{
    boxShadow: ['0 0 0 0px rgba(212, 165, 116, 0)', '0 0 0 4px rgba(212, 165, 116, 0.3)', '0 0 0 8px rgba(212, 165, 116, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-214">
      <span className="relative z-10" data-id="element-215">{text}</span>
      <ArrowRight className="ml-2 w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-216" />

      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0" data-id="element-217" />
    </motion.a>;
}